<template>
  <process-invites-creation-row-header />
</template>
<script>
export default {
  name: "row-header-default"
};
</script>
